/* eslint-disable no-console, no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Lazyload from '../../modules/lazyload';
import MediaGalleryList from './MediaGalleryList';
import Modal from '../modal/Modal';
import { FilterTabItem, FilterSelectBoxItem } from '../media-gallery-filters/FilterTab';
import { FilterSetList } from '../media-gallery-filters/FilterList';
import { getParameterByName } from '../../utils/url-utils';
import ToggleContentToModal from '../../modules/gallery/toggle-content-to-modal';

class MediaGallery extends Component {
  constructor(props) {
    super(props);
    this.allAssetsLoaded = false;

    this.setDefaultFilters = () => {
      const { filterClick, filters } = this.props;
      const defaultFilters = getParameterByName('filters');
      if (defaultFilters !== null && defaultFilters !== '') {
        const filterList = defaultFilters.split(',');
        Object.keys(filters).forEach((filter) => {
          const { options } = filters[filter];
          options.forEach((option) => {
            const { id } = option;
            if (filterList.find(name => name.toLowerCase() === id.toLowerCase())) {
              filterClick(option);
            }
          });
        });
      }

      this.getHashItem = () => {
        // Check for id in url hash
        // If hash exists load modal w/ image
        // data associated w/ that hash value
        const { mediaItems } = this.props;
        const { location } = window;
        const { hash } = location;
        const hashId = hash.substr(1, hash.length);
        // console.log(hashId);
        let hashItem;
        if (hashId !== '' && hashId !== 'media-gallery-list') {
          hashItem = mediaItems.filter(item => item.type === 'Image').find(item => item.imageUrl.indexOf(hashId) !== -1);
        }
        return hashItem;
      };
    };

    // Set default media (Images/Video), if one is checked
    const mediaOptions = props.filters.imagesVideosFilter.options;
    Object.keys(mediaOptions).map((filterKey) => {
      if (mediaOptions[filterKey].isChecked) {
        props.filterClick(mediaOptions[filterKey]);
      }
      return false;
    });
    Object.keys(props.filters).map((filterKey) => {
      props.filters[filterKey].active = false;
      // Set property of isHidden on all filter options
      // Add showMore prop to all categories
      props.filters[filterKey].showMore = (props.filters[filterKey].name === 'Product');
      // Add isHidden prop to all options
      props.filters[filterKey].options.map((optionItem, index) => {
        optionItem.isHidden = (index > 9 && props.filters[filterKey].name === 'Product');
        return false;
      });
      return false;
    });
    // Set default filters if present in query string
    this.setDefaultFilters();
  }

  componentDidMount() {
    Lazyload();
  }

  componentDidUpdate() {
    const {
      assetLoadComplete,
      filterClick,
      filters,
      openModal,
    } = this.props;
    Lazyload();
    if (assetLoadComplete && !this.allAssetsLoaded) {
      // Only runs once, on complete
      this.allAssetsLoaded = true;
      // Set default media (Images/Video), if one is checked
      const mediaOptions = filters.imagesVideosFilter.options;
      filterClick(mediaOptions[0]);
      // Open all filters
      Object.keys(filters).map((filterKey) => {
        filters[filterKey].active = true;
        return false;
      });
      // Needs to run AFTER content has been added to DOM
      setTimeout(() => {
        const filterToggle = new ToggleContentToModal({
          callbacks: {
            onOpen: () => {
              filters.colorRangeFilter.active = true;
              filters.designStyleFilter.active = true;
              filters.productLineFilter.active = true;
              filters.roomTypeFilter.active = true;
            },
            onClose: () => {
              filters.colorRangeFilter.active = true;
              filters.designStyleFilter.active = true;
              filters.productLineFilter.active = true;
              filters.roomTypeFilter.active = true;
            },
          },
          modalId: 'filter-and-sort-modal',
          toggleSelector: '.btn-filter-sort',
          toggleContent: [
            {
              content: '.product-filter-group',
              modalSelector: '#filter-and-sort-modal .product-filter-wrapper',
              defaultSelector: '.filtered-content-grid .product-filter-wrapper',
            },
          ],
        });
        // Open Modal if hashItem returns a reference to a gallery photo
        const hashItem = this.getHashItem();
        if (hashItem) {
          openModal(hashItem);
        }
      }, 100);
    }
  }

  render() {
    const {
      filters,
      buttonClick,
      filterClick,
      clearFilters,
      showAllFilterItems,
      modal,
      mediaItems,
      openModal,
      closeModal,
      savedToFavorites,
      assetId,
      assetLoadComplete,
    } = this.props;

    const secondaryFilters = Object.assign({}, {
      productLineFilter: filters.productLineFilter,
      colorRangeFilter: filters.colorRangeFilter,
      designStyleFilter: filters.designStyleFilter,
      roomTypeFilter: filters.roomTypeFilter,
    });

    const selectBoxChange = (event) => {
      const mediaOptions = filters.imagesVideosFilter.options;
      Object.keys(mediaOptions).map((filterKey) => {
        if (mediaOptions[filterKey].name === event.target.value) {
          filterClick(mediaOptions[filterKey]);
        }
        return false;
      });
    };

    const tabItemClick = (option) => {
      const mediaOptions = filters.imagesVideosFilter.options;
      Object.keys(mediaOptions).map((filterKey) => {
        if (mediaOptions[filterKey].name === option.name) {
          filterClick(mediaOptions[filterKey]);
          clearFilters();
        }
        if (option.name === 'Videos') {
          // Hide filter set
          document.querySelector('.media-gallery-filter').classList.add('hidden');
        } else {
          document.querySelector('.media-gallery-filter').classList.remove('hidden');
        }
        return false;
      });
    };

    let showVideos = false;
    if (filters.imagesVideosFilter.options.length > 0) {
      if (!filters.imagesVideosFilter.options[0].isChecked) {
        showVideos = true;
      }
    }

    return (
      <div className="media-gallery-container">
        <section className={`${(!assetLoadComplete) ? 'hidden' : ''} media-gallery-tabs tabs-section`}>
          <div className="container">
            <div className="tabs-container">
              <ul className="tabs-list nav" role="tablist">
                {filters.imagesVideosFilter.options.map(option => (
                  <FilterTabItem key={option.id} option={option} filterClick={tabItemClick} productRatingImagePath={filters.productRatingImagePath} />
                ))}
              </ul>
            </div>
            <div className="container mobile-tabs-selector site-form">
              <label className="sr-only" htmlFor="imagesVideosFilterSelect">Chose Media Type</label>
              <select onChange={selectBoxChange} id="imagesVideosFilterSelect">
                {filters.imagesVideosFilter.options.map(option => (
                  <FilterSelectBoxItem option={option} />
                ))}
              </select>
            </div>
          </div>
        </section>
        <div className={`${(showVideos || !assetLoadComplete) ? 'hidden' : ''} container mt-1 mb-3`}>
          <div className="product-sort-filter-btn-group">
            <button className="btn-icon btn-filter-sort">Filter &amp; Sort</button>
          </div>
        </div>
        <div className="container two-columns filtered-content-grid">
          <section className="media-gallery-filter product-filter-wrapper two-columns--left">
            <var className="result-total-label sr-only" role="status" aria-live="assertive">Gallery updated, {mediaItems.length} items shown</var>
            <a className="sr-only" href="#media-gallery-list">Skip filters and go to gallery</a>
            <div className="product-filter-group">
              <div role="heading" aria-level="2" className="filter--section-heading">
                Filter
                <button className="clear-btn btn btn-transparent p-0" type="button" onClick={() => clearFilters()}><div className="icon" /> <span>Clear All</span></button>
              </div>
              <FilterSetList filters={secondaryFilters} filterClick={filterClick} buttonClick={buttonClick} showAllFilterItems={showAllFilterItems} />
            </div>
          </section>
          <section className="media-gallery-content two-columns--right" role="tabpanel">
            <MediaGalleryList
              handleMediaClick={openModal}
              items={mediaItems}
              mediaType={showVideos ? 'video' : 'image'}
            />
            <Modal
              modal={modal}
              savedToFavorites={savedToFavorites}
              assetId={assetId}
              handleModalClick={closeModal}
              updateModal={openModal}
            />
          </section>
        </div>
      </div>
    );
  }
}

MediaGallery.propTypes = {
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  buttonClick: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  showAllFilterItems: PropTypes.func.isRequired,
  filters: PropTypes.shape(PropTypes.object),
  modal: PropTypes.shape(PropTypes.object),
  mediaItems: PropTypes.arrayOf(PropTypes.object),
  savedToFavorites: PropTypes.bool.isRequired,
  assetId: PropTypes.string.isRequired,
  assetLoadComplete: PropTypes.bool.isRequired,
};

export default MediaGallery;
/* eslint-enable no-console, no-unused-vars */
